import React, { useState } from 'react';
import { Menu, MenuItem, IconButton } from '@mui/material';
import { useTranslation } from 'react-i18next';

const LanguageSelector = () => {
  const { i18n } = useTranslation();
  const [anchorEl, setAnchorEl] = useState(null);

  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    if (anchorEl) {
      handleClose();
    } else {
      setAnchorEl(event.currentTarget);
    }
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
    localStorage.setItem("selectedLanguage", lng);
    handleClose();
  };

  const currentLanguage = i18n.language || "es";

  const flagEmojis = {
    es: '🇪🇸', // Emoji du drapeau espagnol
    it: '🇮🇹', // Emoji du drapeau italien
  };

  return (
    <div style={{ display: 'flex', alignItems: 'center' }}>
      <IconButton
        aria-controls={open ? 'language-menu' : undefined}
        aria-haspopup="true"
        onClick={handleClick}
        style={{ padding: 0, color: '#fafafa' }}
      >
        <span style={{ fontSize: '1.5rem', marginRight: 5 }}>
          {flagEmojis[currentLanguage]}
        </span>
       
      </IconButton>
      <Menu
        id="language-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        PaperProps={{
          sx: {
            bgcolor: '#1c1c1c',
            color: '#fafafa',
            '& .MuiMenuItem-root:hover': {
              bgcolor: '#333333'
            },
          },
        }}
      >
        <MenuItem onClick={() => changeLanguage('es')}>
          <span style={{ fontSize: '1.5rem', marginRight: 10 }}>🇪🇸</span>
          Español
        </MenuItem>
        <MenuItem onClick={() => changeLanguage('it')}>
          <span style={{ fontSize: '1.5rem', marginRight: 10 }}>🇮🇹</span>
          Italiano
        </MenuItem>
      </Menu>
    </div>
  );
};

export default LanguageSelector;